'use strict';

exports.__esModule = true;
exports.ResetObjectContext = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('../..');

var _2 = _interopRequireDefault(_);

var _ListView = require('../Connectors/Connector/ListView');

var _context = require('../../../context');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Иногда надо иметь возможность сбросить контекст объекта,
 * когда используются вложенные объекты (к примеру, создание нового 
 * объекта внутри контекста другого существующего объекта)
 */


var ResetObjectContext = exports.ResetObjectContext = (_temp = _class = function (_EditorComponent) {
  _inherits(ResetObjectContext, _EditorComponent);

  function ResetObjectContext(props) {
    _classCallCheck(this, ResetObjectContext);

    var _this = _possibleConstructorReturn(this, _EditorComponent.call(this, props));

    _this.state = _extends({}, _this.state, {
      objectContext: {}
    });
    return _this;
  }

  ResetObjectContext.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelButton
    }, 'ResetObjectContext'));
  };

  ResetObjectContext.prototype.getRootElement = function getRootElement() {
    return _EditorComponent.prototype.getRootElement.call(this);
  };

  ResetObjectContext.prototype.canBeParent = function canBeParent(parent) {
    return _EditorComponent.prototype.canBeParent.call(this, parent);
  };

  ResetObjectContext.prototype.canBeChild = function canBeChild(child) {
    return _EditorComponent.prototype.canBeChild.call(this, child);
  };

  ResetObjectContext.prototype.renderChildren = function renderChildren() {
    _objectDestructuringEmpty(this.context);

    var _getEditorContext2 = this.getEditorContext();

    _objectDestructuringEmpty(_getEditorContext2);

    var _getComponentProps = this.getComponentProps(this),
        other = _objectWithoutProperties(_getComponentProps, []);

    var objectContext = this.state.objectContext;
    return _react2.default.createElement(_ListView.ObjectContext.Provider, {
      value: objectContext
    }, _react2.default.createElement(_context.EditableObjectContext.Provider, {
      value: objectContext
    }, _EditorComponent.prototype.renderChildren.call(this)));
  };

  return ResetObjectContext;
}(_2.default), _class.Name = 'ResetObjectContext', _class.defaultProps = _extends({}, _2.default.defaultProps, {
  hide_wrapper_in_default_mode: true
}), _temp);
exports.default = ResetObjectContext;